import type { RealtimeToken } from '@soniox/client'
import { buildTokenRows } from './buildTokenRows'

interface TranscriptTokenStreamProps {
  tokens: RealtimeToken[]
  keyPrefix: string
  showTimestamp?: boolean
  highlightOnArrival?: boolean
}

/**
 * Shared transcript presentation for both live and saved token streams.
 * Containers own scrolling and empty states; this component owns every
 * token-level rule such as speaker labels, sentence breaks and timestamps.
 */
export default function TranscriptTokenStream({
  tokens,
  keyPrefix,
  showTimestamp = false,
  highlightOnArrival = false,
}: TranscriptTokenStreamProps) {
  return <>{buildTokenRows(tokens, keyPrefix, showTimestamp, highlightOnArrival)}</>
}
